import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  background: ${colors.white};
  font-family: ${fonts.body};
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: ${space[4]} ${space[5]};
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${space[7]};
  height: ${space[7]};
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${colors.fontPrimary};
  padding: 0;
  border-radius: ${layout.borderRadiusFull};

  &:hover {
    background: ${colors.lighterGrey};
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
  padding: 0 ${space[5]};
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
`;

export const Section = styled.div<{ $grow?: boolean }>`
  border: 1px solid ${colors.borderGreyLighter};
  border-radius: ${layout.borderRadiusLg};
  background: ${colors.white};
  display: ${({ $grow }) => ($grow ? 'flex' : 'block')};
  flex-direction: column;
  flex: ${({ $grow }) => ($grow ? '1 1 auto' : '0 0 auto')};
  min-height: ${({ $grow }) => ($grow ? '0' : 'auto')};
  overflow: ${({ $grow }) => ($grow ? 'hidden' : 'visible')};
`;

export const SectionHeader = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: transparent;
  border: none;
  padding: ${space[5]};
  cursor: pointer;
  font-family: ${fonts.body};

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
    border-radius: ${layout.borderRadiusLg};
  }
`;

export const SectionLabel = styled.span`
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.bold};
  color: ${colors.fontPrimary};
`;

export const SectionValue = styled.span<{ $placeholder?: boolean }>`
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  color: ${(p) => (p.$placeholder ? colors.fontSecondary : colors.fontPrimary)};
`;

export const SectionBody = styled.div<{ $grow?: boolean; $noPadding?: boolean }>`
  padding: ${({ $noPadding }) => ($noPadding ? '0' : `0 ${space[5]} ${space[5]}`)};
  display: ${({ $grow }) => ($grow ? 'flex' : 'block')};
  flex-direction: column;
  flex: ${({ $grow }) => ($grow ? '1 1 auto' : '0 0 auto')};
  min-height: ${({ $grow }) => ($grow ? '0' : 'auto')};
  overflow: ${({ $grow }) => ($grow ? 'hidden' : 'visible')};
`;

export const CategoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const CategoryOption = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[4]};
  width: 100%;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${(p) => (p.$active ? fonts.weight.semiBold : fonts.weight.medium)};
  color: ${colors.fontPrimary};
  text-align: left;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
    border-radius: ${layout.borderRadiusMd};
  }
`;

export const CategoryThumb = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${space[8]};
  height: ${space[8]};
  border-radius: ${layout.borderRadiusMd};
  background: ${colors.lighterGrey};
  overflow: hidden;
`;

export const CategoryThumbImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space[5]};
  border-top: 1px solid ${colors.borderGreyLighter};
  margin-top: ${space[5]};
`;

export const ResetButton = styled.button`
  background: none;
  border: none;
  padding: ${space[2]} 0;
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.medium};
  color: ${colors.fontPrimary};

  &:hover {
    font-weight: ${fonts.weight.semiBold};
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &:disabled {
    color: ${colors.borderGrey};
    cursor: not-allowed;
  }
`;

export const NextButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${space[3]} ${space[5]};
  background: ${colors.primary};
  color: ${colors.white};
  border: none;
  border-radius: ${layout.borderRadiusFull};
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  transition: opacity 0.15s ease;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;
